import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/geobooster'

const loadMomentForm = () => import('@/vue_widgets/geobooster/moments/form/index.vue')

// Backend (Mobile::CheckinsController + serializer) sends `checkin` because the
// underlying Rails model is still `Mobile::Checkin`. The Vue 3 form is built
// around the user-facing `moment` naming and we don't touch the backend, so we
// rename the prop at the styxie boundary.
function remapCheckinToMoment(props) {
  const { checkin, ...rest } = props || {}
  return { ...rest, moment: checkin }
}

Styxie.Initializers.MobileCheckins = {
  index: async(props) => {
    const { default: MomentsIndex } = await import('@/vue_widgets/geobooster/moments/index/index.vue')
    createVueApp(MomentsIndex, { props, sidebar })
  },
  new: async(props) => {
    const { default: MomentForm } = await loadMomentForm()
    createVueApp(MomentForm, { props: remapCheckinToMoment(props), sidebar })
  },
  edit: async(props) => {
    const { default: MomentForm } = await loadMomentForm()
    createVueApp(MomentForm, { props: remapCheckinToMoment(props), sidebar })
  }
}
